import { z } from 'zod';

export const MenuItem = z.object({
  id: z.string(),
  label: z.string().transform((label) => {
    const exceptions = ['ai'];

    if (exceptions.includes(label.toLowerCase())) {
      return label?.toUpperCase();
    }

    return label
      ? label
          .toLowerCase()
          .split(/\s+/)
          .map((w) => (w ? w[0].toUpperCase() + w.slice(1) : ''))
          .join(' ')
      : '';
  }),
  parentId: z.string().nullable(),
  url: z
    .string()
    .nullish()
    .transform(async (url) => url ?? ''),
});

export const Menu = z.object({
  menus: z.object({
    nodes: z.array(
      z.object({
        menuItems: z.object({
          nodes: z.array(MenuItem),
        }),
      }),
    ),
  }),
});

export type Menu = z.infer<typeof Menu>;
export type MenuItem = z.infer<typeof MenuItem>;
